import { render } from "./indicator.vue?vue&type=template&id=64a7b4d1"
import script from "./indicator.vue?vue&type=script&lang=js"
export * from "./indicator.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__